export default __webpack_public_path__ + "static/media/calendar.941e786e.svg";